import { render, staticRenderFns } from "./warehouse-inventory.vue?vue&type=template&id=3127c54e&scoped=true&"
import script from "./warehouse-inventory.vue?vue&type=script&lang=js&"
export * from "./warehouse-inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3127c54e",
  null
  
)

export default component.exports